import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import CustomLink from '../CustomLink';
import { useExternalLink } from '../../shared/useExternalLink';
import logoSrc from '../../assets/images/powerplay-logo.png';
import styles from './Logo.css';

const cx = classnames.bind(styles);

function Logo({className}) {
    const classes = cx({
        root: true,
        [className]: Boolean(className)
    });
    const {onClick, url} = useExternalLink('counter-strike');
 
    return (
        <CustomLink
            to={url}
            className={classes}
            onClick={onClick}
        >
            <img
                src={logoSrc}
                alt='Powerplay'
            />
        </CustomLink>
    );
}

Logo.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func,
    style: PropTypes.object
};

Logo.defaultProps = {
    onClick: null,
    className: ''
};

export {
    Logo
};
